import { CurrencyPipe, DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from 'app/helpers/authentication.service';
import { Functions } from 'app/helpers/functions';
import { RegrasLimiteDespesasViagensService } from 'app/main/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesa-viagem/services/regras-limite-despesas-viagens.service';
import { FiltroRelatorioDTO } from 'app/shared/filtro-relatorio-despesa-viagem.mode';
import { UsuarioService } from 'app/shared/usuario.service';
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { Observable } from "rxjs";
import { LancamentoDespesaViagemDTO } from "../models/lancamento-despesa-viagem.model";
import { ConfigVersion } from './../../../../../shared/config-version.service';
import { EnumService, EnumTipoCadastroVinculo } from './../../../../../shared/enum.service';
import { VendedoresService } from './../../../supervisor/cadastros/parceiros-negocios/vendedor/vendedores.service';
import { Regras } from './../../../supervisor/cadastros/relatorio-despesas/regras-limite-despesa-viagem/regras-limite-despesa-viagem/regras-limite-despesa-viagem.component';

@Injectable({
    providedIn: 'root'
})
export class PDFDespesaPorConsultorService {

    currencyPipe: CurrencyPipe;
    lancamentoDespesaViagem: LancamentoDespesaViagemDTO = new LancamentoDespesaViagemDTO();
    regrasLimiteDespesasViagensService: any[] = [];
    regras: Regras[] = [];
    limite = 0;
    objRegraLimite: any;

    totalResponse: number = 0;
    totalItens: number = 0;

    constructor(
        protected http: HttpClient,
        private _vendedorService: VendedoresService,
        private authenticationService: AuthenticationService,
        private _regrasLimiteDespesasViagensService: RegrasLimiteDespesasViagensService,
        private configVersion: ConfigVersion,
        private _usuarioService: UsuarioService,
        private _functions: Functions,
        private _datePipe: DatePipe,
        public _enumService: EnumService,
    ) {
        this.listaRegrasJaCadastradas();
    }
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
    }


    setSpaces(quant) {
        let spaces = '';

        for (let i = 0; i < quant; i++) {
            spaces += '&nbsp;';
        }

        return spaces;
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async renderAssinatura(vendedor) {

        let retorno = '';
        if (vendedor != undefined && vendedor != null && vendedor.nmAssinatura != undefined && vendedor.nmAssinatura != null && vendedor.nmAssinatura != '') {
            const htmlAssinatura = `
                <div>
                <img 
                    src="${vendedor.nmAssinatura}"
                    alt="${vendedor.nmAssinatura ? 'Assinatura' : 'Sem imagem'}"
                    height="80px"
                    width="350px"
                />
                <div class="signature-field">
                    <p style="font-size:12px">Assinatura Consultor</p>
                    <p>${this.configVersion.versionActive ? vendedor.nomeVendedor.split(" ")[0] : vendedor.nomeVendedor}</p>
                </div>
            
                <div class="space2"></div>
            `;

            return htmlAssinatura;

        } 
        
        return retorno;
    }

    returnStatusLancamento(status) {
        const text = this._enumService.statusLancamentoDespesa.find(x => x.value == status).text;
        return text;
    }

    renderRelatorios(listRelatorios){
        let cardRelatorio = ``;

        for(let relatorio of listRelatorios){

            cardRelatorio += `
            <div class="card">
                <div class="linha">
                    <div class="coluna-50">
                        <p class="basic-text" style="justify-content: space-between">
                            <b>Descrição: </b>${relatorio.descricaoRelatorio} 
                        </p>
                        <p class="basic-text" style="justify-content: space-between">
                            <b>Empresa: </b>${relatorio.nomeFilial} 
                        </p>                    
                    </div>
                </div>
                <div class="card-coluna-container">
                    ${relatorio.lancamentos.length > 0 ? (this.renderDespesas(relatorio.lancamentos)) : ""}
                </div>
            </div>
            `
        } 
        return cardRelatorio; 
        
    }

    renderDespesas(dadosDespesa) {

        dadosDespesa = dadosDespesa.sort((a, b) => a.tipoDespesa.descricaoCadastro.localeCompare(b.tipoDespesa.descricaoCadastro));
        let card = ``;
        let valorReem = 0;

        for (let despesa of dadosDespesa) {

            this.lancamentoDespesaViagem.tipoDespesaViagemId = despesa.tipoDespesaViagemId;
            this.lancamentoDespesaViagem.tipoPagtoDespesaViagemId = despesa.tipoPagtoDespesaViagemId;

            this.geraListaRegrasJaCadastradas(this.regrasLimiteDespesasViagensService);

            if (despesa.reembolsavel == true) {
                if (despesa.valorDespesa <= this.limite || this.limite == 0) {
                    valorReem = despesa.valorDespesa;
                } else {
                    valorReem = this.limite;                    
                }
            }

            const dateParts = despesa.dataDespesa.split('T')[0].split('-');
            const localDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);

            card += `
            <div class="card-despesa">
                <div class="card-coluna-imagem">
                    <img
                        src="${despesa.caminhoArquivoComprovante}"
                        alt="${'Imagem do comprovante'}"
                        height="auto"
                        width:"auto"
                        style="max-width: 150px; max-heigth: 150px;"
                    />
                </div> 
                <div class="card-coluna-titulos">                    
                    <p class="basic-text"><b>Tipo de Despesa: </b>${despesa.tipoDespesa.descricaoCadastro}</p>
                    <p class="basic-text"><b>Data: </b>${this._datePipe.transform(localDate, 'dd-MM-yyyy')}</p>
                    <p class="basic-text"><b>Tipo de Pagamento: </b>${despesa.tipoPagto.descricaoCadastro}</p>
                    <p class="basic-text"><b>Status: </b>${this.returnStatusLancamento(despesa.statusLancamento)}</p>
                    <p class="basic-text"><b>Valor: </b>${this.formatMoney(despesa.valorDespesa)}</p>
                    <p class="basic-text"><b>Valor Reembolsável: </b>${despesa.reembolsavel == true ? this.formatMoney(valorReem) : '-'}</p>
                    <p class="basic-text"><b>Observação: </b>${despesa.observacoesDespesa}</p>                    
                </div> 
            </div>               
            `
        }
        return card;
    }

    renderTotalPorTipoDespesa(listRelatorios) {
        let totalPorTipoDespesa = '';
        const totaisPorTipo = {};
    
        for (let relatorio of listRelatorios) {
            for (let despesas of relatorio.lancamentos) {
                const despesaId = despesas.tipoDespesaViagemId;
                const despesaDescricao = despesas.tipoDespesa.descricaoCadastro;
                const despesaValor = parseFloat(despesas.valorDespesa);

                if (totaisPorTipo[despesaId]) {
                    totaisPorTipo[despesaId].total += despesaValor;
                } else {
                    totaisPorTipo[despesaId] = {
                        id: despesaId,
                        descricao: despesaDescricao,
                        total: despesaValor
                    };
                }  
            }
        }
    
        totalPorTipoDespesa += `
            <fieldset class="info-container">
                <legend>Total por Tipo de Despesa</legend>
                <div>
                    <table class="table" style="width:100%;">
                        <tr>
                            <th>Despesa</th>
                            <th>Total</th>
                        </tr>`;
    
        for (const despesaId in totaisPorTipo) {
            const totalDespesa = totaisPorTipo[despesaId];
            totalPorTipoDespesa += `
                        <tr>
                            <td class="td">${totalDespesa.descricao}</td>
                            <td class="td">R$${totalDespesa.total.toFixed(2)}</td>
                        </tr>`;
        }
    
        totalPorTipoDespesa += `
                    </table>
                </div>
            </fieldset>
            `;
    
        return totalPorTipoDespesa;
    }
    
    async printRelatorio(relatorios, dataInicio, dataFim) { 

        let vendedor: any;
        await this._vendedorService.getById(relatorios[0].vendedorId).then(async (res) => {            
            if (res != undefined && res != null) {
                vendedor = res;            
            }
        });

        let popupWin;
        popupWin = window.open("", "top=0,left=0,height=auto,width=auto");
        popupWin.document.open();

        await this.delay(3500);
        popupWin.document.write(`
    
        <!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8">
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Relatório de Despesas</title>
                
                <style>
                    body, html {
                        font-family: arial;
                    }
                    
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    
                    :root {
                        --default-text-color: #313131;
                        --primary-text-color: #2ECC71;
                        --cards:#00985E;
                        --main-color: #00A658;
                        --order-status: #00A658;
                        --darker-gray: #AAAAAA;
                        --darkest-gray: #333333;
                        --warning: #FFE922;
                        --danger: #ED462F;
                    }
    
                    #container {
                        position: relative;
                    }
    
                    .header {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                    
                    .header .logo-container {
                        flex-direction: row;
                        justify-content: center;
                        text-align: center;
                    }
                    
                    .header .logo-container img {
                        height: 80px;
                        width: 96px;    
                        margin-left: 10px;
                    }
                    
                    .header .infos-container {
                        margin-left: 8px;
                    }
    
                    .header .infos-container p {
                        max-width: 330px;
                        font-size: 12px;
                        color: var(--darkest-gray);
                    }                    
                    
                    .title-status-container {
                        width:100%;
                        padding: 0 48px;
                        top: 90px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        font-size: 12px;
                        line-height: 12px;
                        margin-bottom: 8px;
                    }
                    
                    .title-status-container h3 {
                        margin-top: 4px;
                    }                    
                    
                    .date-id-container {
                        text-align: right;
                        font-size: 12px;
                    }
                        
                    /* *** CARDS *** */

                    .info-container {
                        border: 1.5px solid var(--cards);
                        border-radius: 6px;
                        padding: 4px 8px; 
                        margin-bottom: 8px;
                        font-size: 12px;
                    }
                    
                    .info-container legend {
                        padding: 4px;
                        color: #FFFFFF;
                        background-color: var(--cards);
                        -webkit-print-color-adjust: exact;
                        font-size: 12px;
                    }

                    .card {
                        border: 1.5px solid var(--darker-gray);
                        border-radius: 6px;
                        padding: 4px 8px; 
                        margin-bottom: 8px;
                        font-size: 12px;
                    }
                    
                    .card-coluna-container {
                        display: flex;
                        flex-direction: column;
                        margin: 0 auto;
                        padding: 10px 0px;
                    }

                    .card-despesa {
                        display: flex;
                        flex-direction: row;
                        margin-bottom: 20px;
                        padding: 10px;
                    }

                    .card-coluna-imagem {
                        flex: 1;
                        padding: 0px 50px;
                    }
            
                    .card-coluna-titulos {
                        flex: 2;
                        padding: 0px 50px;
                        border-left: 1px solid #ccc;
                    }
                    
                    /* * ESTILIZAÇÃO GERAL DAS TABELAS */
                    
                    .info-container .table {
                        margin-top: 8px;
                        margin-bottom: 6px;
                        border-collapse: collapse;
                    }
                    
                    .info-container .table tr th {
                        text-align: left;
                    }
                    
                    .info-container .table tr .td {
                        padding: 2px 0;
                    }
                    
                    .info-container .table tr > .td {
                        border-top: 1px solid var(--darkest-gray);
                    }
                    
                    .info-container .table tr th + th, .info-container .table tr .td + .td {
                        padding-left: 12px;
                    }

                    /* *** ASSINATURAS *** */
                
                    .signatures-container {
                        width:100%;
                        margin-top:40px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        break-inside: avoid;
                    }
                    
                    .signatures-container .space {
                        flex: 1;
                    }

                    .signatures-container .space2 {
                        width: 57%;
                    }
                    
                    .signatures-container .signature-field {
                        border-top: 2px solid var(--darkest-gray);
                        flex: 3;
                        text-align: center;
                    }
                    
                    .signatures-container .signature-field p {
                        font-size: 12px;
                        font-weight: bold;
                    }

                    .linha{
                        display: flex;
                        flex-flow: row wrap;
                        }
                    
                    .coluna-50 {
                        width: 50%;
                    }
                    
                    
                </style>
            </head>
            
            <body> 
                <div class="page">
                    <div id="container">
                        <div class="header">
                            <div style=" justify-content: center; flex-direction:row; display: flex;">
                                <div class="logo-container">                                
                                <img src="${this.configVersion.cliente[this.configVersion.clienteSelecionado].logo}" alt="logo">                            
                                </div>

                                <div class="infos-container" style="margin-top: 0.8em;">
                                    <p>${this.configVersion.cliente[this.configVersion.clienteSelecionado].nome}, ${this.configVersion.cliente[this.configVersion.clienteSelecionado].cnpj}</p>                            
                                    <p>${this.configVersion.cliente[this.configVersion.clienteSelecionado].rua}, ${this.configVersion.cliente[this.configVersion.clienteSelecionado].numero} - ${this.configVersion.cliente[this.configVersion.clienteSelecionado].cep}</p>
                                    <p>${this.configVersion.cliente[this.configVersion.clienteSelecionado].cidade} - ${this.configVersion.cliente[this.configVersion.clienteSelecionado].uf}</p>
                                </div>
                            </div>  
                            
                            <div class="date-id-container">
                                <p>Data: ${moment(new Date()).format('DD/MM/YYYY')}</p>
                            </div>
                        </div>

                        <div>
                            <div class="title-status-container">
                                <h3>DESPESAS POR CONSULTOR NO PERÍODO</h3>
                            </div>
                        </div>
        
                        <!-- *** DADOS DO RELATÓRIO ***-->
                        <fieldset class="info-container">
                            <legend>Dados do Relatório</legend>
        
                            <div class="linha">
                                <p class="basic-text" style="justify-content: space-between">
                                    <b>Nome: </b>${this.configVersion.versionActive ? vendedor.nomeVendedor.split(" ")[0] : vendedor.nomeVendedor}${this.setSpaces(30)} 
                                </p>
                            </div>
                            <div class="linha">
                                <p class="basic-text" style="justify-content: space-between">
                                    <b>Período: </b>${moment(dataInicio).format('DD/MM/YYYY')} - ${moment(dataFim).format('DD/MM/YYYY')}
                                </p>
                            </div>
                            </div>
                        </fieldset>
                                        
                        <!-- *** DESPESAS ***-->
                        <fieldset class="info-container">
                            <legend>Despesas</legend>
                            ${relatorios.length > 0 ? (this.renderRelatorios(relatorios)) : ""}
                        </fieldset>

                        <!-- *** VALORES TOTAIS POR TIPO DESPESA ***-->
                        ${relatorios.length > 0 ? (this.renderTotalPorTipoDespesa(relatorios)) : ""}

                        <!-- *** ASSINATURAS *** -->
                        <div class="signatures-container">  
                            ${await this.renderAssinatura(vendedor)}
                        </div>
                        
                    </div>
                </div>    
            </body>
            <div style="display: flex; justify-content: end;">
                <p style="position: fixed; bottom: 0; text-align: right; font-size: 10px;">By: A2W Tecnologia</p>
            </div>
        </html>
    
        `);
        await this.delay(3500);

        popupWin.document.close();
        popupWin.print();
        
    }

    async listaRegrasJaCadastradas() {
        let filtros: FiltroRelatorioDTO = new FiltroRelatorioDTO();
        filtros.pageSize = 100;
        this.totalItens = 0;
        do{
            await this._regrasLimiteDespesasViagensService.getAllPaginated(filtros)
                .then(result => {
                    this.regrasLimiteDespesasViagensService = this.regrasLimiteDespesasViagensService.concat(result.regrasLimiteDespesaViagem.filter(x => x.statusCadastro == 1));
                    this.totalItens += result.regrasLimiteDespesaViagem.length;
                    this.totalResponse = result.totalItens;
                    filtros.pageIndex++;
                });
        } while(this.totalItens < this.totalResponse);
    }

    geraListaRegrasJaCadastradas(listaRegrasLimiteDespesaViagem) {

        listaRegrasLimiteDespesaViagem.forEach(regra => {

            const provi = new Regras();
            provi.valor = regra.valorRegra;
            provi.regra = regra;

            regra.vinculosLimiteDespesaViagens.forEach(vinculo => {
                if (vinculo.tipoVinculo == EnumTipoCadastroVinculo["Tipo de Despesa"]) {
                    provi.despesa = vinculo.tipoVinculoReferenciaId;
                } else if (vinculo.tipoVinculo == EnumTipoCadastroVinculo["Tipo de Pagamento"]) {
                    provi.pagto = vinculo.tipoVinculoReferenciaId;
                } else if (vinculo.tipoVinculo == EnumTipoCadastroVinculo["Grupo de Usuário"]) {
                    provi.grupo = vinculo.tipoVinculoReferenciaId;
                }
            });

            this.regras.push(provi);

        });

        this.consultaRegras();
    }

    consultaRegras() {

        this.limite = 0;

        this.regras.forEach(gp => {
            
            let regra1 = false;
            let regra2 = false;
            let regra3 = false;

            if (gp.grupo && gp.despesa && gp.pagto) {
                if (gp.grupo == this.authenticationService.currentUserValue.userDetails.userGroupId &&
                    parseInt(gp.despesa) == this.lancamentoDespesaViagem.tipoDespesaViagemId &&
                    parseInt(gp.pagto) == this.lancamentoDespesaViagem.tipoPagtoDespesaViagemId) {
                    
                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                    regra1 = true;
                }
            } else if (gp.grupo && gp.despesa && !gp.pagto) {
                if (gp.grupo == this.authenticationService.currentUserValue.userDetails.userGroupId &&
                    parseInt(gp.despesa) == this.lancamentoDespesaViagem.tipoDespesaViagemId) {

                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                    regra2 = true;
                }
            } else if (gp.grupo && !gp.despesa && gp.pagto) {
                if (gp.grupo == this.authenticationService.currentUserValue.userDetails.userGroupId &&
                    parseInt(gp.pagto) == this.lancamentoDespesaViagem.tipoPagtoDespesaViagemId) {
                    
                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                }
            } else if (gp.grupo && !gp.despesa && !gp.pagto) {
                if (gp.grupo == this.authenticationService.currentUserValue.userDetails.userGroupId) {
                    
                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                    regra3 = true;
                }
            } else if (!gp.grupo && gp.despesa && gp.pagto) {
                if (parseInt(gp.despesa) == this.lancamentoDespesaViagem.tipoDespesaViagemId &&
                    parseInt(gp.pagto) == this.lancamentoDespesaViagem.tipoPagtoDespesaViagemId) {
                    
                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                }
            } else if (!gp.grupo && gp.despesa && !gp.pagto) {
                if (parseInt(gp.despesa) == this.lancamentoDespesaViagem.tipoDespesaViagemId) {
                    
                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                }
            } else if (!gp.grupo && !gp.despesa && gp.pagto) {
                if (parseInt(gp.pagto) == this.lancamentoDespesaViagem.tipoPagtoDespesaViagemId) {
                    
                    this.limite = gp.valor;
                    this.objRegraLimite = gp;
                }
            }

        });
    }

    formatMoney(value) {
        const temp = `${value}`.replace(/\,/g, "");
        this.currencyPipe = new CurrencyPipe('pt-BR');
        return this.currencyPipe.transform(temp, 'BRL');
    }

}
